import { render, staticRenderFns } from "./hdraces-frame.vue?vue&type=template&id=a13b7456"
import script from "./hdraces-frame.vue?vue&type=script&lang=js"
export * from "./hdraces-frame.vue?vue&type=script&lang=js"
import style0 from "./hdraces-frame.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/hdraces/hdraces-frame.vue
// module id = KzuZ
// module chunks = 0